const OnlyHeader = () => {
  return (
    <>
      <div className="header  text-dark pb-7 pt-5 pb-md-8 pt-md-7"></div>
    </>
  );
};

export default OnlyHeader;
